'use strict';

// Deshabilitando SOLICITUDES NUEVAS DE SHB a solicitud de SENAVEX porque se migrará a

import Bandeja from './bandeja/bandeja.sellobolivia.module';
import Solicitud from './solicitud/solicitud.sellobolivia.module';

const Components = angular
    .module('app.sellobolivia', [
        Bandeja,
        Solicitud
    ])
    .name;

export default Components;



// WEBPACK FOOTER //
// ./src/app/components/sellobolivia/sellobolivia.module.js